export interface FieldConfig {
  key: string;
  label: string;
  type: 'text' | 'textarea' | 'richtext' | 'image' | 'video' | 'url' | 'color';
  defaultValue: string;
  placeholder?: string;
  helpText?: string;
}

export interface SectionConfig {
  id: string;
  label: string;
  description?: string;
  fields: FieldConfig[];
}

export interface PageConfig {
  slug: string;
  name: string;
  description: string;
  path: string;
  sections: SectionConfig[];
}

export const pageConfigs: PageConfig[] = [
  {
    slug: 'home',
    name: 'Home',
    description: 'De hoofdpagina van Vermado',
    path: '/',
    sections: [
      {
        id: 'hero',
        label: 'Hero Sectie',
        description: 'De grote banner bovenaan de pagina',
        fields: [
          { key: 'hero_video_url', label: 'Achtergrond video', type: 'video', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/hero-vid.mp4' },
          { key: 'hero_headline', label: 'Headline', type: 'text', defaultValue: 'HIGH END AUTOMOTIVE' },
          { key: 'hero_description', label: 'Beschrijving', type: 'textarea', defaultValue: 'Bij Vermado High-End Automotive staan prestaties en vakmanschap centraal. Van chiptuning tot uitlaatsystemen en custom modificaties – wij halen het maximale uit uw voertuig.' },
          { key: 'hero_accent_before', label: 'Accent tekst (voor)', type: 'text', defaultValue: 'Prestatie geeft ' },
          { key: 'hero_accent_highlight', label: 'Accent highlight', type: 'text', defaultValue: 'vrijheid' },
          { key: 'hero_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'BEKIJK ONZE SHOP' },
          { key: 'hero_button_url', label: 'Knop URL', type: 'url', defaultValue: 'https://shop.vermado.nl' },
          { key: 'hero_trust_text', label: 'Vertrouwenstekst', type: 'text', defaultValue: 'Premium service voor uw voertuig' },
          { key: 'hero_feature_1', label: 'Feature 1', type: 'text', defaultValue: 'Advies op maat' },
          { key: 'hero_feature_2', label: 'Feature 2', type: 'text', defaultValue: 'Gecertificeerde werkplaats' },
          { key: 'hero_feature_3', label: 'Feature 3', type: 'text', defaultValue: 'Volledige ontzorging' },
          { key: 'hero_feature_4', label: 'Feature 4', type: 'text', defaultValue: 'Maximale zekerheid' },
        ],
      },
      {
        id: 'welcome',
        label: 'Welkom Sectie',
        fields: [
          { key: 'welcome_image', label: 'Welkom afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/intro-vm.webp' },
          { key: 'welcome_statement', label: 'Welkomst tekst', type: 'textarea', defaultValue: 'Bij Vermado draait alles om exclusieve voertuigen en geavanceerde motoroptimalisatie. Wij combineren passie voor prestaties met vakmanschap op het hoogste niveau. Voor autoliefhebbers die het beste verwachten.' },
          { key: 'welcome_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'Meer over Vermado' },
        ],
      },
      {
        id: 'chiptuning',
        label: 'Chiptuning Sectie',
        fields: [
          { key: 'chiptuning_image', label: 'Chiptuning afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/niveaeokl.jpg' },
          { key: 'chiptuning_title', label: 'Titel (HTML)', type: 'richtext', defaultValue: "BRENG JE AUTO NAAR HET <br /><span class='italic'>VOLGENDE NIVEAU</span>" },
          { key: 'chiptuning_description', label: 'Beschrijving', type: 'text', defaultValue: 'Technologische perfectie op de weg met 100% tevredenheid.' },
          { key: 'chiptuning_stat1_number', label: 'Statistiek 1 nummer', type: 'text', defaultValue: '33' },
          { key: 'chiptuning_stat1_label', label: 'Statistiek 1 label', type: 'text', defaultValue: 'Gemiddeld meer vermogen' },
          { key: 'chiptuning_stat2_number', label: 'Statistiek 2 nummer', type: 'text', defaultValue: '100' },
          { key: 'chiptuning_stat2_label', label: 'Statistiek 2 label', type: 'text', defaultValue: 'Vernieuwde prestaties' },
          { key: 'chiptuning_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'CHIPTUNING' },
        ],
      },
      {
        id: 'services',
        label: 'Diensten Sectie',
        fields: [
          { key: 'services_title', label: 'Titel (HTML)', type: 'richtext', defaultValue: 'BEKIJK ONZE<br />DIENSTEN EN EXPERTISES' },
          { key: 'services_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'ALLE DIENSTEN BEKIJKEN' },
          { key: 'service_ppf-wrap_image', label: 'PPF Wrap afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/ppfwraps.jpg' },
          { key: 'service_ppf-wrap_title', label: 'PPF Wrap titel', type: 'text', defaultValue: 'PPF WRAP' },
          { key: 'service_chiptuning_image', label: 'Chiptuning afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/GP%20Products-11.jpg' },
          { key: 'service_chiptuning_title', label: 'Chiptuning titel', type: 'text', defaultValue: 'CHIPTUNING' },
          { key: 'service_modificaties_image', label: 'Modificaties afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/mods.jpg' },
          { key: 'service_modificaties_title', label: 'Modificaties titel', type: 'text', defaultValue: 'MODIFICATIES' },
          { key: 'service_tuning-kits_image', label: 'Tuning Kits afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/tuningkits.jpg' },
          { key: 'service_tuning-kits_title', label: 'Tuning Kits titel', type: 'text', defaultValue: 'TUNING KITS' },
        ],
      },
      {
        id: 'calculator',
        label: 'Kenteken Calculator',
        fields: [
          { key: 'calculator_title', label: 'Titel', type: 'text', defaultValue: 'CHIPTUNING DOOR VERMADO' },
          { key: 'calculator_subtitle', label: 'Subtitel', type: 'text', defaultValue: 'BEREKEN EENVOUDIG DE VERMOGENSWINST VOOR JOUW AUTO' },
        ],
      },
    ],
  },
  {
    slug: 'expertises',
    name: 'Expertises',
    description: 'Overzicht van alle expertises',
    path: '/expertises',
    sections: [
      {
        id: 'hero',
        label: 'Hero Sectie',
        fields: [
          { key: 'hero_bg_image', label: 'Achtergrond afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/GP%20Products-11.jpg' },
          { key: 'hero_headline', label: 'Headline', type: 'text', defaultValue: 'ONZE EXPERTISES' },
          { key: 'hero_description', label: 'Beschrijving', type: 'textarea', defaultValue: 'Ontdek onze premium diensten en expertise op het gebied van automotive modificatie en optimalisatie. Van PPF Wrap tot Chiptuning, wij bieden alleen het beste voor uw voertuig.' },
          { key: 'hero_accent_before', label: 'Accent tekst (voor)', type: 'text', defaultValue: 'Prestatie geeft ' },
          { key: 'hero_accent_highlight', label: 'Accent highlight', type: 'text', defaultValue: 'vrijheid' },
          { key: 'hero_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'Bekijk onze expertises' },
          { key: 'exp_feature_1', label: 'Feature 1', type: 'text', defaultValue: 'Chiptuning' },
          { key: 'exp_feature_2', label: 'Feature 2', type: 'text', defaultValue: 'PPF & Wrapping' },
          { key: 'exp_feature_3', label: 'Feature 3', type: 'text', defaultValue: 'Uitlaatsystemen' },
          { key: 'exp_feature_4', label: 'Feature 4', type: 'text', defaultValue: 'Modificaties' },
        ],
      },
      {
        id: 'cta',
        label: 'CTA Sectie',
        fields: [
          { key: 'cta_image', label: 'CTA Afbeelding', type: 'image', defaultValue: 'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?q=80&w=2940&auto=format&fit=crop' },
          { key: 'cta_title', label: 'CTA Titel', type: 'text', defaultValue: 'Maak je afspraak' },
          { key: 'cta_description', label: 'CTA Beschrijving', type: 'textarea', defaultValue: 'Maak je afspraak via onze planning tool en boek direct jouw afspraak bij Vermado.' },
          { key: 'cta_button_text', label: 'CTA Knop tekst', type: 'text', defaultValue: 'Plan direct' },
        ],
      },
    ],
  },
  {
    slug: 'werkplaats',
    name: 'Werkplaats',
    description: 'De werkplaats pagina',
    path: '/werkplaats',
    sections: [
      {
        id: 'hero',
        label: 'Hero Sectie',
        fields: [
          { key: 'hero_bg_image', label: 'Achtergrond afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/GP%20Products-11.jpg' },
          { key: 'hero_headline', label: 'Headline', type: 'text', defaultValue: 'WERKPLAATS' },
          { key: 'hero_description', label: 'Beschrijving', type: 'textarea', defaultValue: 'Ervaar het verschil met onze premium service en expertise. Voor al uw onderhoud en custom werkzaamheden.' },
          { key: 'hero_accent_before', label: 'Accent tekst (voor)', type: 'text', defaultValue: 'Prestatie geeft ' },
          { key: 'hero_accent_highlight', label: 'Accent highlight', type: 'text', defaultValue: 'vrijheid' },
          { key: 'hero_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'Bekijk onze werkplaats' },
          { key: 'hero_trust_text', label: 'Vertrouwenstekst', type: 'text', defaultValue: 'Professionele automotive service' },
          { key: 'werk_feature_1', label: 'Feature 1', type: 'text', defaultValue: 'Onderhoud' },
          { key: 'werk_feature_2', label: 'Feature 2', type: 'text', defaultValue: 'Diagnose' },
          { key: 'werk_feature_3', label: 'Feature 3', type: 'text', defaultValue: 'Montage' },
          { key: 'werk_feature_4', label: 'Feature 4', type: 'text', defaultValue: 'Custom werk' },
        ],
      },
    ],
  },
  {
    slug: 'contact',
    name: 'Contact',
    description: 'De contactpagina',
    path: '/contact',
    sections: [
      {
        id: 'hero',
        label: 'Hero Sectie',
        fields: [
          { key: 'hero_bg_image', label: 'Achtergrond afbeelding', type: 'image', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/GP%20Products-11.jpg' },
          { key: 'hero_headline', label: 'Headline', type: 'text', defaultValue: 'CONTACT' },
          { key: 'hero_description', label: 'Beschrijving', type: 'textarea', defaultValue: 'Heeft u vragen of wilt u een afspraak maken? Neem dan contact met ons op via onderstaande mogelijkheden.' },
          { key: 'hero_accent_before', label: 'Accent tekst (voor)', type: 'text', defaultValue: 'Prestatie geeft ' },
          { key: 'hero_accent_highlight', label: 'Accent highlight', type: 'text', defaultValue: 'vrijheid' },
          { key: 'hero_button_text', label: 'Knop tekst', type: 'text', defaultValue: 'Bel ons direct' },
          { key: 'hero_trust_text', label: 'Vertrouwenstekst', type: 'text', defaultValue: 'Wij staan voor u klaar' },
          { key: 'contact_feature_1', label: 'Feature 1', type: 'text', defaultValue: 'Telefoon & WhatsApp' },
          { key: 'contact_feature_2', label: 'Feature 2', type: 'text', defaultValue: 'E-mail' },
          { key: 'contact_feature_3', label: 'Feature 3', type: 'text', defaultValue: 'Werkplaats bezoek' },
          { key: 'contact_feature_4', label: 'Feature 4', type: 'text', defaultValue: 'Vrijblijvend advies' },
        ],
      },
      {
        id: 'details',
        label: 'Contactgegevens',
        fields: [
          { key: 'contact_phone', label: 'Telefoonnummer', type: 'text', defaultValue: '+31 6 27225807' },
          { key: 'contact_email', label: 'E-mailadres', type: 'text', defaultValue: 'info@vermado.nl' },
          { key: 'contact_address', label: 'Adres', type: 'textarea', defaultValue: 'Netwerk 12 A\n1446WK Purmerend' },
          { key: 'contact_kvk', label: 'KVK-nummer', type: 'text', defaultValue: '90898184' },
        ],
      },
      {
        id: 'faq',
        label: 'Veelgestelde Vragen',
        fields: [
          { key: 'faq_question_1', label: 'Vraag 1', type: 'text', defaultValue: 'Wat zijn jullie openingstijden?' },
          { key: 'faq_answer_1', label: 'Antwoord 1', type: 'textarea', defaultValue: 'Wij zijn geopend van maandag t/m vrijdag van 08:00 tot 17:00 uur. In het weekend zijn wij gesloten.' },
          { key: 'faq_question_2', label: 'Vraag 2', type: 'text', defaultValue: 'Kan ik zonder afspraak langskomen?' },
          { key: 'faq_answer_2', label: 'Antwoord 2', type: 'textarea', defaultValue: 'Wij werken uitsluitend op afspraak om u de beste service te kunnen garanderen. Maak eenvoudig een afspraak via ons contactformulier, telefoon of WhatsApp.' },
          { key: 'faq_question_3', label: 'Vraag 3', type: 'text', defaultValue: 'Hoe kan ik het beste een afspraak maken?' },
          { key: 'faq_answer_3', label: 'Antwoord 3', type: 'textarea', defaultValue: 'U kunt een afspraak maken via ons contactformulier, telefonisch of via WhatsApp. Wij nemen dan zo spoedig mogelijk contact met u op.' },
          { key: 'faq_question_4', label: 'Vraag 4', type: 'text', defaultValue: 'Wat zijn de betalingsmogelijkheden?' },
          { key: 'faq_answer_4', label: 'Antwoord 4', type: 'textarea', defaultValue: 'Wij accepteren PIN, contant en bankoverschrijving. Voor zakelijke klanten is betaling op factuur mogelijk.' },
        ],
      },
    ],
  },
  {
    slug: 'onze-collectie',
    name: 'Onze Collectie',
    description: 'De collectie pagina',
    path: '/onze-collectie',
    sections: [
      {
        id: 'hero',
        label: 'Hero Sectie',
        fields: [
          { key: 'hero_video_url', label: 'Achtergrond video', type: 'video', defaultValue: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Vermado%20automotive%20website%20banner%20video%20(1).mp4' },
          { key: 'hero_headline', label: 'Headline', type: 'text', defaultValue: 'ONZE COLLECTIE' },
          { key: 'hero_description', label: 'Beschrijving', type: 'textarea', defaultValue: 'Ontdek onze exclusieve selectie van premium voertuigen. Elk voertuig wordt zorgvuldig geselecteerd en gecontroleerd.' },
          { key: 'collectie_feature_1', label: 'Feature 1', type: 'text', defaultValue: 'Geselecteerde voertuigen' },
          { key: 'collectie_feature_2', label: 'Feature 2', type: 'text', defaultValue: 'BOVAG garantie' },
          { key: 'collectie_feature_3', label: 'Feature 3', type: 'text', defaultValue: 'Uitgebreide keuring' },
          { key: 'collectie_feature_4', label: 'Feature 4', type: 'text', defaultValue: 'Financiering mogelijk' },
        ],
      },
    ],
  },
];

export function getPageConfig(slug: string): PageConfig | undefined {
  return pageConfigs.find((p) => p.slug === slug);
}

export function getExpertiseDetailConfig(expertiseId: string): PageConfig {
  return {
    slug: `expertise-${expertiseId}`,
    name: `Expertise: ${expertiseId}`,
    description: `Detail pagina voor ${expertiseId}`,
    path: `/expertises/${expertiseId}`,
    sections: [
      {
        id: 'hero',
        label: 'Hero Sectie',
        fields: [
          { key: 'hero_bg_image', label: 'Achtergrond afbeelding', type: 'image', defaultValue: '' },
          { key: 'hero_subtitle', label: 'Subtitel', type: 'text', defaultValue: '' },
          { key: 'hero_title', label: 'Titel', type: 'text', defaultValue: '' },
          { key: 'hero_description', label: 'Beschrijving', type: 'textarea', defaultValue: '' },
        ],
      },
      {
        id: 'stats',
        label: 'Statistieken',
        fields: [
          { key: 'stat_projects_value', label: 'Projecten waarde', type: 'text', defaultValue: '500+' },
          { key: 'stat_projects_label', label: 'Projecten label', type: 'text', defaultValue: 'Projecten' },
          { key: 'stat_experience_value', label: 'Ervaring waarde', type: 'text', defaultValue: '10+' },
          { key: 'stat_experience_label', label: 'Ervaring label', type: 'text', defaultValue: 'Jaar ervaring' },
          { key: 'stat_satisfaction_value', label: 'Tevredenheid waarde', type: 'text', defaultValue: '100%' },
          { key: 'stat_satisfaction_label', label: 'Tevredenheid label', type: 'text', defaultValue: 'Tevredenheid' },
          { key: 'stat_clients_value', label: 'Klanten waarde', type: 'text', defaultValue: '1000+' },
          { key: 'stat_clients_label', label: 'Klanten label', type: 'text', defaultValue: 'Tevreden klanten' },
        ],
      },
    ],
  };
}
